export default {
  displayFont : '"Work Sans", sans-serif',
  bodyFont    : '"Work Sans", sans-serif',
  colors: {
    tones: {
      lightest : '#F5F5F5',
      lighter  : '#EBEBEB',
      light    : '#969696',
      dark     : '#373737',
      darker   : '#141414'
    },
    accents: {
      primary   : '#104D80',
      secondary : '#DDE6ED'
    },
    primary   : '#004178',
    secondary : '#9BB4C8',
    text      : '#646464',
    highlight : '#00964B'
  },
  navHeight: 80,
  grid: {
    breakpoints: { // defaults below
      xxl     : 1930,
      giant   : 1420,
      xl      : 1200,
      desktop : 992,
      lg      : 992,
      tablet  : 768,
      md      : 768,
      phone   : 576,
      sm      : 576,
      smaller : 575,
      xs      : 575,
    },
    row: {
      padding: 20, // default 15
    },
    col: {
      padding: 20, // default 15
    },
    container: {
      padding: 50, // default 15
    }
  }
};



// WEBPACK FOOTER //
// ./src/ui/styles/theme.js